import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, ButtonMode, EmployeesIcon, MoreIcon, Popover } from 'edenred-ui';
import { useDispatch } from 'react-redux';

import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import {
  IBenefitGroupSettings,
  IBenefitGroupTile
} from '@epi-models/pages/BenefitGroups';

import { BenefitTile } from '../BenefitTile';

import {
  BorderLeft,
  DropdownButton,
  GrayBorderSmallButton,
  SmallButton
} from './BenefitGroupTile.styles';

export const BenefitGroupTile = ({ benefitGroup }: IBenefitGroupTile) => {
  const dispatch = useDispatch();
  const { gray10, sizeMedium, fontSemiBold, primaryFrontColor } = useTheme();
  const [showDropdown, setShowDropdown] = useState(false);
  const openDropdown = event => {
    setShowDropdown(event.currentTarget);
  };
  const closeDropdown = () => setShowDropdown(false);
  const { t } = useTranslation();

  const navigateToEmployees = (): void => {
    dispatch(goToPage(routerPaths.beneficiaries));
  };

  return (
    <Box
      border={1}
      borderColor={gray10}
      height={264}
      maxWidth={362}
      minWidth={296}
    >
      <Box p={3} display="flex" flexDirection="column" height="100%">
        <Box pb={2}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box fontSize={sizeMedium} fontWeight={fontSemiBold}>
              {benefitGroup.groupName}
            </Box>
            <Popover
              open={!!showDropdown}
              anchorEl={showDropdown}
              onClose={closeDropdown}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <Box minWidth={260}>
                {/* NOTE: Edit button click will be handled later (with add/edit benefit group page) */}
                {/* <DropdownButton
                  id="dropdown-action-edit-btn"
                  onClick={() => console.log('clicked edit')}
                >
                  <Box display="flex" gap={1.5}>
                    <EditIcon color={primaryFrontColor} />
                    {t('containers.benefit_groups.edit')}
                  </Box>
                </DropdownButton> */}
                <DropdownButton
                  id="dropdown-action-manage-btn"
                  onClick={navigateToEmployees}
                >
                  <Box display="flex" gap={1.5}>
                    <EmployeesIcon color={primaryFrontColor} />
                    {t('containers.benefit_groups.manage_employees')}
                  </Box>
                </DropdownButton>
              </Box>
            </Popover>
            <Box onClick={openDropdown}>
              <MoreIcon />
            </Box>
          </Box>
          <Box pt={2} display="flex" gap={1}>
            {benefitGroup?.beneficiaryCount === 0 && (
              <SmallButton
                mode={ButtonMode.Secondary}
                onClick={navigateToEmployees}
              >
                {t('containers.benefit_groups.add_employees')}
              </SmallButton>
            )}
            {benefitGroup?.beneficiaryCount >= 0 && (
              <GrayBorderSmallButton
                mode={ButtonMode.Secondary}
                onClick={navigateToEmployees}
              >
                {benefitGroup?.beneficiaryCount}{' '}
                {t('containers.benefit_groups.employees')}
              </GrayBorderSmallButton>
            )}
            {/* NOTE: NEW tag label logic will be added later (with add benefit group page) */}
            {/* <PositiveLabel>{t('containers.benefit_groups.new')}</PositiveLabel> */}
          </Box>
        </Box>
        <BorderLeft mt="auto">
          <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={1.5}>
            {benefitGroup?.benefitSettings?.map(
              (benefitSetting: IBenefitGroupSettings, index) => (
                <BenefitTile
                  key={'benefit-tile-' + index}
                  type={benefitSetting.benefitType}
                  limit={benefitSetting.maxAmountPerPeriod}
                />
              )
            )}
          </Box>
        </BorderLeft>
      </Box>
    </Box>
  );
};
